<template>
  <div>
    <section class="section-product">
      <div class="container">
          <!-- <div class="row">
            <div class="col-12">
              <b-breadcrumb :items="breadcrumbs" />
            </div>
          </div> -->
          <div class="row">
            <div class="col-sm-6">
              <img :src="`https://www.arctec.ie/static/img/product/${product.productId}.jpg`"/>
            </div>
            <div class="col-sm-6 pl-3 pr-3 pt-3 pt-sm-0 text-center text-sm-right">
              <h4 class="text-primary">
                {{product.name}}
              </h4>
              <h6 class="text-muted">
                {{productBrandNames}}
              </h6>
              <a :href="'mailto:sales@arctec.ie?Subject=Website%20enquiry: ' + product.name + '&body=Website Enquiry - Product: ' + product.name" rel="noopener"
                 target="_blank"
                 class="btn btn-info btn-icon">
                  <span class="btn-inner--icon">
                    <i class="fa fa-envelope mr-2"></i>
                  </span>
                  <span class="nav-link-inner--text">Enquire Now</span>
              </a>
              <a :href="`https://www.arctec.ie/static/catalogues/${product.productId}.pdf`"
                 rel="noopener"
                 target="_blank"
                 class="btn btn-light btn-icon">
                  <span class="btn-inner--icon">
                    <i class="fa fa-download mr-2"></i>
                  </span>
                  <span class="nav-link-inner--text">View PDF</span>
              </a>
            </div>
          </div>
          <div class="row mt-5">
            <div class="col-12">
              <h6 class="text-muted text-bold text-uppercase">
                Description
              </h6>
              <p>
                {{product.description}}
              </p>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-12">
              <h6 class="text-muted text-bold text-uppercase">
                Technical Specifications
              </h6>
              <p>
                <span class="font-bold">Net Weight:</span> {{product.netMass}} {{product.massUnit}}
              </p>
            </div>
          </div>
      </div>
    </section>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import _ from 'lodash'
import { Breadcrumb } from 'bootstrap-vue'

export default {
  name: 'Product',
  components: {
    Breadcrumb,
  },
  data() {
    // const { categoryId, productId } = this.$route.params
    // return {
    //   breadcrumbs: [
    //     {
    //       text: 'Products',
    //     },
    //     {
    //       text: categoryId,
    //       href: `#/products/${productName}`,
    //     },
    //   ],
    // }
    return {}
  },
  methods: mapActions(['fetchBrands', 'fetchCategories', 'fetchProduct']),
  created() {
    this.fetchBrands()
    this.fetchCategories()
    this.fetchProduct(this.$route.params.productId)
  },
  computed: {
    ...mapGetters(['product', 'brands']),
    productBrandNames() {
      const productBrands = _.filter(this.brands, brand => {
        _.includes(this.product.brandIds, brand.id)
      })
      const productBrandNames = _.map(this.filteredBrands, 'name')
      return _.join(productBrandNames, ',')
    }
  }
}
</script>
